import { computed, Injectable, signal } from '@angular/core';

export interface BreadcrumbItem {
  name: string;
  url: string;
}

export interface PageBefore {
  name: string;
  url: string;
}

@Injectable({ providedIn: 'root' })
export class PageTitleService {
  pageTitle = signal<string>('');
  pageSubtitle = signal<string>('');
  _pagesBefore = signal<PageBefore | null>(null);
  _breadcrumbs = signal<BreadcrumbItem[]>([]);

  setTitle(title: string) {
    this.pageTitle.set(title);
  }

  setSubtitle(subtitle: string) {
    this.pageSubtitle.set(subtitle);
  }

  setPagesBefore(pagesBefore: PageBefore | null) {
    this._pagesBefore.set(pagesBefore);
    // Sync breadcrumbs from pagesBefore for backward compatibility
    if (pagesBefore) {
      this._breadcrumbs.set([{ name: pagesBefore.name, url: pagesBefore.url }]);
    } else {
      this._breadcrumbs.set([]);
    }
  }

  setBreadcrumbs(breadcrumbs: BreadcrumbItem[]) {
    this._breadcrumbs.set(breadcrumbs);
    // Sync pagesBefore from last breadcrumb for backward compatibility
    if (breadcrumbs.length > 0) {
      const last = breadcrumbs[breadcrumbs.length - 1];
      this._pagesBefore.set({ name: last.name, url: last.url });
    } else {
      this._pagesBefore.set(null);
    }
  }

  setPage(config: { title: string; subtitle?: string; breadcrumbs?: BreadcrumbItem[] }) {
    this.setTitle(config.title);
    this.setSubtitle(config.subtitle ?? '');
    this.setBreadcrumbs(config.breadcrumbs ?? []);
  }

  get title() {
    return computed(() => this.pageTitle());
  }

  get subtitle() {
    return computed(() => this.pageSubtitle());
  }

  get pagesBefore() {
    return computed(() => this._pagesBefore());
  }

  get breadcrumbs() {
    return computed(() => this._breadcrumbs());
  }
}
